import store from '../../../store/store';
import { OffCanvasAction, OffCanvasConfigs } from '../interfaces/off-canvas.interface';
import { StoreState } from '../../../store/store.interface';
import {
  getClearOffCanvasAction,
  getFocusInOffCanvasAction,
  getOpenOffCanvasAction,
} from '../store/off-canvas.selector';
import { triggerClearOffCanvasDismiss, triggerFocusInOffCanvasDismiss } from '../store/off-canvas.store';

/**
 * Focuses the off-canvas element from the off-canvas action.
 *
 * @param parent
 * @param state
 */
export function focusOffCanvasElement(parent: Element | ShadowRoot, state: StoreState): void {
  const focusInOffCanvasAction: OffCanvasAction | undefined = getFocusInOffCanvasAction(state);

  if (focusInOffCanvasAction) {
    (parent.querySelector(focusInOffCanvasAction.focusElementSelector ?? '') as HTMLElement)?.focus();
    store.dispatch(triggerFocusInOffCanvasDismiss());
  }
}

/**
 * Verifies if the off-canvas elements should be cleared.
 *
 * @param offCanvasId
 * @param state
 */
export function shouldClearOffCanvasElements(offCanvasId: string, state: StoreState): boolean {
  const clearOffCanvasAction: OffCanvasAction | undefined = getClearOffCanvasAction(state);

  if (clearOffCanvasAction && clearOffCanvasAction.offCanvasId === offCanvasId) {
    store.dispatch(triggerClearOffCanvasDismiss());
    return true;
  }

  return false;
}

/**
 * Verifies if an open action is trigerred on an off canvas
 *
 * @param offCanvasId
 * @param state
 */
export function isOffCanvasOpening(offCanvasId: string, state: StoreState): boolean {
  const openOffcanvasAction: OffCanvasAction | undefined = getOpenOffCanvasAction(state);
  return !!(openOffcanvasAction && openOffcanvasAction.offCanvasId === offCanvasId);
}

/**
 * Determines if the off-canvas is the last off-canvas in the list.
 *
 * @param offCanvasId
 * @param offCanvasConfigs
 */
export function isLastOffCanvas(offCanvasId: string, offCanvasConfigs?: OffCanvasConfigs): boolean {
  if (!offCanvasConfigs) {
    return false;
  }

  const offCanvasIds = Object.keys(offCanvasConfigs);
  return offCanvasIds.indexOf(offCanvasId) === offCanvasIds.length - 1;
}
